







































































import { Component, Watch, Mixins } from 'vue-property-decorator';
import AssignOperator from '@/components/shipment/AssignOperator.vue';
import Callout from '@/components/Callout.vue';
import ChannelSelect from '@/components/channel/ChannelSelect.vue';
import CopyShipment from '@/components/CopyShipment.vue';
import NavBar from '@/components/layout/NavBar.vue';
import NavBarNavigation from '@/components/layout/NavBarNavigation.vue';
import FollowShipment from '@/components/shipment/FollowShipment.vue';

// mixins
import channels from '@/mixins/channels.ts';
import fromTo from '@/mixins/fromTo';

// gql
import fetchInquiryQuery from '@/graphql/queries/FetchInquiry.gql';

// types
import { InquiryFields, InquiryStatusEnum } from '@/types/graphql/schemaTypes';
import { NavigationSection } from '@/types/types';

@Component({
  components: {
    AssignOperator,
    Callout,
    ChannelSelect,
    CopyShipment,
    FollowShipment,
    NavBar,
    NavBarNavigation
  },
  apollo: {
    inquiry: {
      query: fetchInquiryQuery,
      prefetch: true,
      variables() {
        return {
          inquiryArgs: {
            inquiryId: this.$route.params.id
          }
        };
      },
      update(data) {
        const inquiry = data && data.inquiries && data.inquiries[0];

        if (inquiry) {
          // reopen channel that are in open state
          this.reopenChannel(inquiry.channelList);
        }
        return inquiry;
      },
      fetchPolicy: 'network-only'
    }
  }
})
export default class InquiryMain extends Mixins(channels, fromTo) {
  public inquiry: InquiryFields | null = null;
  public isModalVisible = false;
  public navigationSections: NavigationSection[] = [
    {
      i18nKey: 'inquiry.navbar.quote',
      name: 'inquiryQuote'
    },
    {
      i18nKey: 'inquiry.navbar.details',
      name: 'inquiryDetails'
    },
    {
      i18nKey: 'inquiry.navbar.task',
      name: 'inquiryTasks'
    },
    {
      i18nKey: 'shared.file',
      name: 'inquiryAttachments'
    },
    {
      i18nKey: 'shared.labels.channel',
      name: 'inquiryChannels'
    }
  ];

  mounted() {
    this.$root.$on('channelCreated', this.refetchInquiry);
  }

  destroyed() {
    this.$root.$off('channelCreated', this.refetchInquiry);
  }

  private acceptInquiry(): void {
    this.$store.dispatch('App/openConfirmationModal', {
      dispatch: 'Inquiry/acceptInquiry',
      payload: {
        inquiryId: this.inquiry && this.inquiry.id
      },
      options: {
        color: 'primary',
        titleLabel: `${this.$t('inquiry.confirm-accept')}`
      }
    });
  }

  private deleteInquiry(): void {
    this.$store.dispatch('App/openConfirmationModal', {
      dispatch: 'Inquiry/deleteInquiry',
      payload: {
        id: this.inquiry && this.inquiry.id
      },
      options: {
        titleLabel: `${this.$t('shipment.confirm.archive-title')}`,
        modalContent: `${this.$t('shipment.confirm.archive-body')}`
      }
    });
  }

  private unarchive() {
    if (this.inquiry) {
      this.$store.dispatch('App/openConfirmationModal', {
        dispatch: 'Inquiry/unarchiveInquiry',
        payload: this.inquiry.id,
        options: {
          titleLabel: `${this.$t('shipment.confirm.unarchive-title')}`
        }
      });
    }
  }

  private refetchInquiry(): void {
    this.$apollo.queries.inquiry.refetch();
  }

  get calloutActions() {
    if (this.inquiry) {
      const actions = [{ label: 'shared.accept', event: 'accept' }];
      if (this.inquiry.status === InquiryStatusEnum.inquiry_cancelled) {
        actions.push({ label: 'shipment.unarchive', event: 'unarchive' });
      } else {
        actions.push({ label: 'shipment.archive', event: 'delete' });
      }
      return actions;
    }
  }

  @Watch('$store.state.Inquiry.action')
  private refresh(action: string) {
    if (action === 'accept') {
      this.$router.push({ name: 'shipmentActivities' });
      this.$store.dispatch('Inquiry/setAction', '');
    }
    if (action === 'delete') {
      this.$router.push({ name: 'inquiries' });
      this.$store.dispatch('Inquiry/setAction', '');
    }
    if (action === 'update') {
      this.refetchInquiry();
      this.$store.dispatch('Inquiry/setAction', '');
    }
  }
}
